const locale = require('./bindAction.i18n.json');

/*@ngInject*/
const BindActionModalController = function ($rootScope, $scope, options, localization, coreConstant) {

    $scope.i18n = _.get(locale, options.translationRoot);

    $scope.titleText = '';
    $scope.titleText = options.notificationPreference ? options.notificationPreference.title : _.get($scope.i18n, 'title');
    $scope.summary = _.get($scope.i18n, 'summary');
    $scope.cancelButton = _.get($scope.i18n, 'cancel');
    $scope.confirmButton = _.get($scope.i18n, 'confirm');
    $scope.quotes = _.map(options.quoteList, function (quote) {
        var matches = 0;
        if (_.isNil(quote.grouping)) {
            quote.grouping = '';
        } else {
            _.each(options.quoteList, function (tempQuote) {
                if (tempQuote.grouping === quote.grouping) {
                    matches++;
                }
            });
            if (matches <= 1) {
                quote.grouping = '';
            }
        }
        return quote;
    });
    $scope.quotes = _.sortBy($scope.quotes, ['grouping', 'value']);
    $scope.quoteList = _.groupBy($scope.quotes, 'grouping');
    _.each($scope.quoteList, function (quoteArrayObject) {
        quoteArrayObject = _.sortBy(quoteArrayObject, ['value']);
    });
    $scope.selectedQuotes = [];


    if ($scope.quotes.length === 1) {
        $scope.selectedQuotes.push($scope.quotes[0]);
        $scope.quotes[0].checked = true;
    } else {
        _.each($scope.quotes, function (quote) {
            if (_.endsWith(quote.value, 'true')) {
                $scope.selectedQuotes.push(quote);
                quote.checked = true;
            }
        });
    }


    $scope.handleClick = function (item, group) {

        if (group) {
            if (_.some($scope.selectedQuotes, ['grouping', item.grouping])) {
                _.remove($scope.selectedQuotes, function (currentObject) {
                    return currentObject.grouping === item.grouping;
                });
            }
            $scope.selectedQuotes.push(item);
        } else {
            if (item.checked) {
                $scope.selectedQuotes.push(item);
            } else {
                _.pull($scope.selectedQuotes, item);
            }
        }

    };

    $scope.canEnableConfirmButton = function () {
        return $scope.selectedQuotes.length !== 0;
    };

    $scope.onConfirm = function () {
        var quoteIds = [];
        _.each($scope.selectedQuotes, function (quote) {
            quoteIds.push(parseInt(_.split(quote.value, '::')[0]));
        });
        $scope.$close({
            selectedQuoteIds: quoteIds
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('bindActionModalController', BindActionModalController);
